export function resolveCompanyLogoUrl(logoValue, origin = typeof window !== 'undefined' ? window.location.origin : '') {
  const rawLogo = String(logoValue || '').trim();
  if (!rawLogo) return '';
  if (/^https?:\/\//i.test(rawLogo) || rawLogo.startsWith('data:')) {
    return rawLogo;
  }
  if (!origin) return rawLogo;
  return `${origin}${rawLogo.startsWith('/') ? rawLogo : `/${rawLogo}`}`;
}
